import * as React from "react";

function SvgActiveCampaign(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 288 288"
      overflow="visible"
      {...{ ...props, ref }}
    >
      <style>{".ActiveCampaign_svg__st1{fill:#fff}"}</style>
      <path
        id="ActiveCampaign_svg__Rectangle_1_"
        d="M36 0h216c19.9 0 36 16.1 36 36v216c0 19.9-16.1 36-36 36H36c-19.9 0-36-16.1-36-36V36C0 16.1 16.1 0 36 0z"
        fill="#356ae6"
      />
      <path
        className="ActiveCampaign_svg__st1"
        d="M146.7 150.7c2.6 0 5.2-1 8-3.1 3.3-2.3 6.2-4.2 6.2-4.2l1-.7-1-.7c-.4-.3-43.9-30.5-48.4-33.4-2.1-1.5-4.5-1.8-6.4-.9-1.8.9-2.8 2.8-2.8 5.1v10.3l.4.2c.3.2 30.2 21 36 24.9 2.4 1.7 4.7 2.5 7 2.5z"
      />
      <path
        className="ActiveCampaign_svg__st1"
        d="M205.1 132.6c-2.6-1.9-95.9-67-99.9-69.8l-1.3-.9v16c0 5.1 2.7 7 6 9.4 0 0 71.6 49.9 80.5 56-8.9 6.2-76.3 52.9-80.6 55.6-5.1 3.4-5.6 5.6-5.6 10.2v17.2s98.7-70.6 100.8-72.2c4.5-3.4 5.5-7.4 5.6-10.3V142c0-3.6-1.8-6.8-5.5-9.4z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgActiveCampaign);
